import GitHubCalendar from 'react-github-calendar';
import ReactTooltip from 'react-tooltip'
import React from 'react';
import Stats from './Stats';
import "../Styles/Github.css"

const GithubCalender = () => {
  //     const selectLastHalfYear = contributions => {
  //   const currentYear = new Date().getFullYear();
  //   const currentMonth = new Date().getMonth();
  //   const shownMonths = 6;

  //   return contributions.filter(day => {
  //     const date = new Date(day.date);
  //     const monthOfDay = date.getMonth();

  //     return (
  //       date.getFullYear() === currentYear &&
  //       monthOfDay > currentMonth - shownMonths &&
  //       monthOfDay <= currentMonth
  //     );
  //   });
  // };
  return (
    <div id="github">
    <div className='imp'>
      <h1 className='calheader' >Github Calender</h1>
    <div data-aos="flip-left" id="call">
      <GitHubCalendar username="chintasiva"  style={{ margin: "auto" }}
        // transformData={selectLastHalfYear}
        blockSize={18}
        fontSize={20}
        blockMargin={7}
      >
        <div data-aos="flip-right">
          <ReactTooltip delayShow={20} html />
        </div>
      </GitHubCalendar>
     
    </div>
     <Stats />
     </div>
     </div>
  );
}

export default GithubCalender;